import { Button, Col, message, Modal, Row, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { deleteAutoDownloadTask, getAutoDownloadTaskList, getJt808VideoAccessTaskAllTags } from "@/service/jtDevicePlayback";
import CommonTable from "@/components/commonTable";
import RenderEllipsisColumn from "@/components/renderEllipsisColumn";
import DatePicker from "@/components/datePicker";
import _ from "lodash";
import { Dayjs } from "dayjs";
import axios from "axios";
import { carListRequest } from "@/service/carManage";
import { useUserCateIdArr } from "@/utils/ownHooks";
import { title } from "process";
import { render } from "react-dom";

type RangeValue = [Dayjs | null, Dayjs | null] | null;

const { RangePicker } = DatePicker;
const AutoDownloadModal = (prop: any) => {
  const { visible, onCancel } = prop;
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [carId, setCarId] = useState<number | null>(null);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [timeRange, setTimeRange] = useState<RangeValue>(null);
  const [allStatus, setAllStatus] = useState<any[]>([]);
  const [selectStatus, setSelectStatus] = useState<any[]>([]);
  const onPageChange = (page: number, pageSize: number) => {
    setPage(page);
    setLimit(pageSize);
  };
  const cateIdArr = useUserCateIdArr();

  const updateTableData = async () => {
    setLoading(true);


    const params: any = {
      carId,
      size: limit,
      current: page,
    
    };

    if (timeRange && timeRange[0] && timeRange[1]) {
      params.beginTime = timeRange[0].format("YYYY-MM-DD HH:mm:ss");
      params.endTime = timeRange[1].format("YYYY-MM-DD HH:mm:ss");
    }
    if (selectStatus) {
      params.status = selectStatus;
    }

    try {
      const res = await getAutoDownloadTaskList(params);

      const resData = res?.data?.data || [];
      const total = res?.data?.count || 0;
      setTableData(resData);
      setTotalCount(total);
    } catch (e) {
      console.error("获取自动下载任务列表失败", e);
      setTableData([]);
    }


    setLoading(false);
  };

  const AutoDownloadTaskColumns = [
    {
      title: '车牌号',
      dataIndex: 'plateNumber', width: 120,
      ellipsis: { showTitle: false },
      render: (value: string) => (
        <RenderEllipsisColumn text={value} />
      ),
    },
    {
      title : '时间范围',
      dataIndex: 'timeRange', width: 200,
      ellipsis: { showTitle: false }, 
      render:(value: string, record: any) => {
        const { beginTime, endTime } = record;
        return (
          <RenderEllipsisColumn text={`${beginTime} - ${endTime}`} />
        );
      }
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt', width: 120,
      ellipsis: { showTitle: false },
      render: (value: string) => (
        <RenderEllipsisColumn text={value} />
      ),
    },
    {
      title: '通道号',
      dataIndex: 'channel', width: 120,
      ellipsis: { showTitle: false },
      render: (value: string) => (
        <RenderEllipsisColumn text={value} />
      ),
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      width: 120,
      ellipsis: { showTitle: false },
      render: (value: string) => (
        <RenderEllipsisColumn text={value} />
      ),
    },
    {
      title: '操作',
      dataIndex: 'url',
      width: 120,
      ellipsis: { showTitle: false },
      render: (value: string, record: any) => (
        <div>
          {
            value?.trim() && <a href={value.trim()} target="_blank" rel="noopener noreferrer">下载视频</a>
          }
          <Button type="link" danger
            onClick={() => {
              const taskId = record.id; // 获取任务ID
              console.log("删除任务", taskId);
              delTask(taskId);
            }}>
            删除
          </Button>
        </ div>
      )
    }
  ];


  const delTask = async (taskId: number) => {
    try {
      // 调用删除任务的API
      await deleteAutoDownloadTask(taskId);
      message.success("删除任务成功");
      // 成功后重新加载表格数据
      updateTableData();
    } catch (error) {
      console.error("删除任务失败", error);
    }
  }

  // useEffect(() => {
  //   if (visible && carId) {
  //     updateTableData();
  //   }
  // }, []);


  useEffect(() => {
    // 当页码或每页条数变化时，重新加载数据
    if (visible && carId) {
      updateTableData();
    }
  }, [page, limit]);
  const requestController = useRef<any>(null);
  const [isPlateLoading, setIsPlateLoading] = useState<boolean>(false);
  const [plateNumberOptions, setPlateNumberOptions] = useState<any[]>([]);

  const _handlePlateNumberSearch = async (val: string) => {
    setIsPlateLoading(true);
    const params = {
      page: 1,
      limit: 200,
      cate_id: cateIdArr,
    } as any;

    const plateNumber = (val || '').trim();
    if (plateNumber) {
      params.plateNumber = plateNumber;
    }
    try {
      // 取消上一个请求
      if (requestController.current) {
        requestController.current.cancel();
      }

      // 创建一个新的请求控制器
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      requestController.current = source;

      const res = await carListRequest({ ...params, cancelToken: source.token });
      const resData = res?.data?.data as any[] || [];
      setPlateNumberOptions(
        resData.map(
          (item: any) => ({
            label: item.plate_number,
            value: item.carId,
          }))
      );
    } catch (error) {
      setPlateNumberOptions([]);
      console.error("获取车牌号列表失败", error);
    } finally {
      setIsPlateLoading(false);
    }
  }

  const debounceHandlePlateNumberSearch = _.debounce(_handlePlateNumberSearch, 200);

  const getAllStatus = async () => {
    try {
      const res = await getJt808VideoAccessTaskAllTags();
      const resData = res?.data?.data || []
      setAllStatus(resData.map((item: any) => ({
        label: item.first,
        value: item.second,
      })));
    } catch (error) {
      message.error('获取标签失败');
      setAllStatus([]);
    }

  }

  useEffect(() => {
    _handlePlateNumberSearch(''); // 初始化时加载车牌号列表
    getAllStatus();
  }, []);

  return (
    <Modal onCancel={onCancel} open={visible} width={800} title="自动下载任务" footer={null}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col span={6}>
          <Select
            style={{ width: "100%", marginBottom: 16 }}
            placeholder="请选择车牌号"
            value={carId}
            onChange={(value) => setCarId(value)}
            options={isPlateLoading ? [{
              label: '正在加载数据...',
              value: 'loading',
              disabled: true
            }] : plateNumberOptions}
            showSearch
            onSearch={debounceHandlePlateNumberSearch}
            filterOption={false}
            defaultActiveFirstOption={false}
            allowClear
            onBlur={() => {
              setIsPlateLoading(false);
              setPlateNumberOptions([]);
            }}
            loading={isPlateLoading}
          />
        </Col>
        <Col span={6}>
          <Select
            style={{ width: "100%", marginBottom: 16 }}
            placeholder="请选择任务状态"
            options={allStatus}
            value={selectStatus}
            onChange={(value) => setSelectStatus(value)}
            allowClear
          ></Select>
        </Col>
        <Col span={15}>
          <RangePicker
            style={{ width: "100%", marginBottom: 16 }}
            showTime
            value={timeRange}
            onChange={(dates) => setTimeRange(dates)}
            placeholder={['开始时间', '结束时间']}
          />
        </Col>
        <Col span={3}>
          <Button type="primary" onClick={updateTableData}>
            查询
          </Button>
        </Col>
      </Row>

      <CommonTable
        dataSource={tableData}
        columns={AutoDownloadTaskColumns}
        columnFilter={false}
        size="small"
        scroll={{ y: 600 }}
        loading={loading}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange,
        }}
        bordered
      />
    </Modal>
  );
};


export default AutoDownloadModal;